import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RelatorioDTO } from '../../../dtos/relatorio-dto';
import { Filial } from '../../../filial/filial';
import { FilialService } from '../../../filial/filial.service';
import { ProcedimentoConsulta } from '../../../procedimento/procedimento-consulta/procedimento-consulta';
import { ProcedimentoConsultaService } from '../../../procedimento/procedimento-consulta/procedimento-consulta.service';
import { ChaveValorStrInterface } from '../../../util/chave-valor-str-interface';
import { Util } from '../../../util/util';
import { CustomDateValidator } from '../../../validators/custom-date-validator';
import { RelatorioConsultaService } from '../relatorio-consulta.service';

@Component({
  selector: 'app-rel-disponibilidade-vagas-consulta',
  templateUrl: './rel-disponibilidade-vagas-consulta.component.html',
  styleUrls: ['./rel-disponibilidade-vagas-consulta.component.css']
})
export class RelDisponibilidadeVagasConsultaComponent implements OnInit {

  formularioDeDisponibilidadeDeVagas: FormGroup;

  listaFiliais: Filial[];

  listaTipoAgrupamentoDisponibilidadeDeVagasParaConsulta: ChaveValorStrInterface[];

  listaDeProcedimentoConsulta: ProcedimentoConsulta[];

  constructor(private relatorioService: RelatorioConsultaService,
    private filialService: FilialService,
    private procedimentoConsultaService: ProcedimentoConsultaService,
    private formBuilder: FormBuilder) {

    this.formularioDeDisponibilidadeDeVagas = this.formBuilder.group({
      filial: ['', [Validators.required]],
      dataInicial: [''],
      dataFinal: [''],
      codTipoAgrupamento: ['0', [Validators.required]],
      procedimentos: ['', [Validators.required]],
    }, {
      validator: [CustomDateValidator('dataInicial'),
      CustomDateValidator('dataFinal')],
    });

    this.listaFiliais = [];

    this.listaTipoAgrupamentoDisponibilidadeDeVagasParaConsulta = Util.listaTipoAgrupamentoDisponibilidadeDeVagasParaConsulta;

    this.listaDeProcedimentoConsulta = [];
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarProcedimentosConsulta();
  }

  onSubmit() {
    this.gerarRelatorio();
  }

  gerarRelatorio(): void {

    const relatorioDTO: RelatorioDTO = Object.assign(new RelatorioDTO(), this.formularioDeDisponibilidadeDeVagas.value);

    const procedimentos: ProcedimentoConsulta[] = this.controlProcedimentos.value;
    const idsProcedimentos: number[] = [];

    procedimentos.forEach((element) => {
      idsProcedimentos.push(element.id);
    });

    relatorioDTO.idsNumberArray = idsProcedimentos;

    this.relatorioService.gerarRelatorioDeDisponibilidadeDeVagas(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  listarProcedimentosConsulta() {
    this.procedimentoConsultaService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaDeProcedimentoConsulta = data;

      }, error => {
        console.log(error);
      });
  }

  get controlProcedimentos() {

    return this.formularioDeDisponibilidadeDeVagas.controls.procedimentos;

  }

}
